var _path, _path2, _path3, _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 576,
    viewBox: "0 0 576 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306 12H494.111L568 85.8889V332H306V12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 415C16 406.163 23.1634 399 32 399H125.163C128.858 399 132.439 400.279 135.299 402.62L170.136 431.143C173.848 434.182 176 438.726 176 443.523V543C176 551.837 168.837 559 160 559H32C23.1634 559 16 551.837 16 543V415Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H318.75L333.5 0H443L576 133V576H158L0 416V20Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 487,
    width: 116,
    height: 64,
    fill: "url(#pattern0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2619_19837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V53.4445L17.7553 71.1998V36.4751H35.0104V19.22H80.0595V0H0ZM28.9729 18.1483C28.9729 24.1143 24.1143 28.9729 18.1483 28.9729C12.1822 28.9729 7.32361 24.1143 7.32361 18.1483C7.32361 12.1822 12.1822 7.32361 18.1483 7.32361C24.1143 7.32361 28.9729 12.1822 28.9729 18.1483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.495 0H83.3105V19.22H102.495V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.288 0H106.104V19.22H125.288V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.288 22.1852H106.104V31.7952H125.288V22.1852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.509 0H128.324V19.22H147.509V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1484 21.8637C20.1847 21.8637 21.8281 20.2203 21.8281 18.184C21.8281 16.1477 20.1847 14.5043 18.1484 14.5043C16.1121 14.5043 14.4688 16.1477 14.4688 18.184C14.4688 20.2203 16.1121 21.8637 18.1484 21.8637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32452 66.234C5.21675 66.234 3.50195 67.9488 3.50195 70.0566C3.50195 72.1643 5.21675 73.9149 7.32452 73.9149C9.43229 73.9149 11.1828 72.2001 11.1828 70.0566C11.1828 67.9131 9.46801 66.234 7.32452 66.234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32452 81.5957C5.21675 81.5957 3.50195 83.3105 3.50195 85.454C3.50195 87.5975 5.21675 89.2766 7.32452 89.2766C9.43229 89.2766 11.1828 87.5618 11.1828 85.454C11.1828 83.3462 9.46801 81.5957 7.32452 81.5957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32452 96.9574C5.21675 96.9574 3.50195 98.6722 3.50195 100.816C3.50195 102.959 5.21675 104.674 7.32452 104.674C9.43229 104.674 11.1828 102.959 11.1828 100.816C11.1828 98.6722 9.46801 96.9574 7.32452 96.9574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32452 112.319C5.21675 112.319 3.50195 114.034 3.50195 116.142C3.50195 118.249 5.21675 120 7.32452 120C9.43229 120 11.1828 118.285 11.1828 116.142C11.1828 113.998 9.46801 112.319 7.32452 112.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.512 7.8595H153.188V19.1843H164.512V7.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.518 7.8595H170.193V19.1843H181.518V7.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.487 7.8595H187.162V19.1843H198.487V7.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.493 7.8595H204.168V19.1843H215.493V7.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.499 7.8595H221.174V19.1843H232.499V7.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.503 7.8595H238.178V19.1843H249.503V7.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.508 7.8595H255.184V19.1843H266.508V7.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.477 7.8595H272.152V19.1843H283.477V7.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.483 7.8595H289.158V19.1843H300.483V7.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.162 7.8595V19.22H317.487L306.162 7.8595Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2619_19837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.048 24.4358L493.043 24.665L493.272 24.4358L493.048 24.4358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.516 54.0321L523.516 65.3458L524.113 65.9434L524.113 54.6297L523.516 54.0321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.725 52.2393L521.725 63.553L522.322 64.1506L522.322 52.8369L521.725 52.2393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.926 50.4421L519.93 61.7603L520.528 62.3579L520.528 51.0442L519.926 50.4421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.133 48.6494L518.133 59.9631L518.735 60.5651L518.73 49.2469L518.133 48.6494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.363 46.879L516.368 58.1972L516.965 58.7948L516.965 47.4811L516.363 46.879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.57 45.0862V56.4L515.168 56.9975L515.168 45.6838L514.57 45.0862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.777 43.2935L512.777 54.6072L513.375 55.2048L513.375 43.8911L512.777 43.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.984 41.5007V52.8144L511.582 53.412L511.582 42.0983L510.984 41.5007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.191 39.708L509.191 51.0217L509.789 51.6193L509.789 40.3056L509.191 39.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.395 37.9108L507.395 49.2245L507.997 49.8266L507.997 38.5128L507.395 37.9108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.602 36.118L505.602 47.4317L506.199 48.0293L506.199 36.7156L505.602 36.118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.811 34.3252L503.811 45.6389L504.408 46.2365L504.408 34.9228L503.811 34.3252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.018 32.5325L502.018 43.8462L502.615 44.4438L502.615 33.1301L502.018 32.5325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.225 30.7397L500.225 42.0534L500.822 42.651L500.822 31.3373L500.225 30.7397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.428 28.9424L498.428 40.2562L499.03 40.8582L499.03 29.5445L498.428 28.9424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.635 27.1497L496.635 38.4634L497.232 39.061L497.232 27.7472L496.635 27.1497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.842 25.3569L494.842 36.6706L495.439 37.2682L495.439 25.9545L494.842 25.3569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.273 24.4358L493.044 24.665L493.048 34.8778L493.646 35.4754L493.646 24.4403L493.273 24.4358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.252 26.4578L491.257 33.0851L491.854 33.6827L491.85 25.8602L491.252 26.4578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.459 28.2505L489.459 31.2878L490.061 31.8899L490.057 27.6529L489.459 28.2505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.94 29.7692L488.264 30.0927L488.264 29.4457L487.94 29.7692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.424 86.9398L555.826 86.3422L555.826 88.2743L556.428 87.6722L556.424 86.9398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.057 84.5719L554.061 90.04L554.659 89.4425L554.659 85.174L554.057 84.5719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.264 82.7792L552.264 91.8373L552.866 91.2352L552.861 83.3768L552.264 82.7792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.471 80.9864L550.471 92.3001L551.068 92.8977L551.068 81.584L550.471 80.9864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.678 79.1937L548.678 90.5074L549.275 91.105L549.275 79.7913L548.678 79.1937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.885 77.4009L546.885 88.7146L547.482 89.3122L547.482 77.9985L546.885 77.4009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.088 75.6036L545.088 86.9173L545.69 87.5194L545.69 76.2057L545.088 75.6036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.295 73.8109L543.295 85.1246L543.893 85.7221L543.893 74.4084L543.295 73.8109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.502 72.0181L541.502 83.3318L542.1 83.9294L542.1 72.6157L541.502 72.0181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.709 70.2253L539.709 81.5391L540.307 82.1366L540.307 70.8229L539.709 70.2253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.916 68.4326L537.916 79.7463L538.514 80.3439L538.514 69.0302L537.916 68.4326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.119 66.6353L536.119 77.949L536.721 78.5511L536.721 67.2374L536.119 66.6353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.326 64.8426L534.326 76.1563L534.924 76.7539L534.924 65.4402L534.326 64.8426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.535 63.0498L532.535 74.3635L533.133 74.9611L533.133 63.6474L532.535 63.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.742 61.2571L530.742 72.5708L531.34 73.1684L531.34 61.8547L530.742 61.2571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.943 59.4598L528.948 70.778L529.545 71.3756L529.545 60.0619L528.943 59.4598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.152 57.6671L527.152 68.9808L527.754 69.5828L527.75 58.2646L527.152 57.6671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.359 55.8743L525.359 67.188L525.957 67.7856L525.957 56.4719L525.359 55.8743Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2619_19837",
    transform: "matrix(0.00788177 0 0 0.0142857 -0.0899015 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2619_19837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317.487,
    height: 120,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2619_19837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.5314,
    height: 8,
    fill: "white",
    transform: "translate(493.484 24) rotate(45)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2619_19837",
    width: 200,
    height: 70,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABGCAYAAACJ4ts2AAAACXBIWXMAAAsSAAALEgHS3X78AAAB1UlEQVR4nO3cwW7qMBBA0eGp///LeVKlbqrUIsF2PONzVmxACHEZ20Bex3Eckcsr2fMlsX8Jn3q2oEnsK9En8vHrtknCcJkmyO8gTBKGy7bEEglTZdyDiIRpMgYSImGWrIGESJghcyAhEkbLHkiIhJEqBBIiYZQqgYRIGKFSICESeqsWSIiEnioGEiKhl6qBhEjooXIgIRI+VT2QEAmf2CGQEAl37RJIiIQ7dgokRMJVuwUSIuGKHQMJkfCuXQMJkfCOr81fpdfJ1VLevR8b2HmC/LjzZjdtNrH7BPnxbiSuzbUZE+Qa+5bNCOQ6kWxEIPeIZBMCuU8kGxDIZ0RSnEA+dxaJUIoQSB9nx70iKUAg/YikIIGMJ5LEBNLXX9+siyQpgfQnkkIEMoZIihDIOCIpQCBjiSQ5gYwnksQEModIkhLIPCJJSCBziSQZgcwnkkQE8gz/ZU9CIM/x48YEBPIskSxOIM97+WfiugSyDpEsSCBrEcliBLIeJ1wLEciaRLIIgUCDQKDB1d3JqvcBxumyViA1Of267vQ1s8SCBhOktsqnYaOXWN+PLxCymhK/JRY0CAQaBAIN9iBw7nuPY4JAg0CgQSDQYA+yPj8beZAJAn+JiP+qTkCbWxYFrQAAAABJRU5ErkJgggA="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayLeftBg);
export default __webpack_public_path__ + "static/media/display_left_bg.0712aeb460cff8341b86259ee1bdfebb.svg";
export { ForwardRef as ReactComponent };